import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useAuth } from '../../../contexts/AuthContext'

function RoleBasedRoute({ children, allowedRoles = ['admin'], requireClientAccess = false }) {
  const { user, profile, loading, isAdmin, assignedClient } = useAuth()
  const location = useLocation()
  const { clientId } = useParams()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Profile not loaded yet
  if (!profile) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // Check role permission
  if (!allowedRoles.includes(profile.role)) {
    // Client user trying to access admin routes - redirect to their portal
    if (profile.role === 'client' && assignedClient) {
      return <Navigate to={`/portal/${assignedClient.id}`} replace />
    }
    return <Navigate to="/login" replace />
  }

  // If route requires client access, verify the user can access this client
  if (requireClientAccess && clientId) {
    if (profile.role === 'client' && assignedClient?.id !== clientId) {
      // Client user trying to access different client - redirect to their portal
      return <Navigate to={`/portal/${assignedClient.id}`} replace />
    }
  }

  return children
}

export default RoleBasedRoute
